module.exports = __webpack_public_path__ + "img/a1.d380b4ab.svg";